import { sendRawRequest } from "@api/clients/axios";
import type { AxiosHttpError } from "@types_def/common/error.types";

export type ChangePasswordInput = {
  username: string;
  code: string;
  password: string;
};
export async function changePassword(input: ChangePasswordInput) {
  try {
    const res = await sendRawRequest<ChangePasswordInput, Record<string, never>>(
      "post",
      "/auth/confirm-password-submit",
      input
    );
    return { success: true, data: res.data };
  } catch (err: unknown) {
    const axiosError = err as AxiosHttpError;
    const message = axiosError.response?.data.message;
    return {
      success: false,
      message: typeof message === "string" ? message : message?.join(" "),
    };
  }
}
